import { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import HeaderDashboard from "../../Components/HeaderDashboard";
import $ from "jquery";
import "jquery-ui-dist/jquery-ui";
import "jquery-ui-dist/jquery-ui.css";
import { InsuranceTransactionReport } from "../../Services/ReservationsApi";

const AllTransactions = () => {
    const [filters, setFilters] = useState({
        fromDate: "",
        toDate: "",
        //transactionId: "",
        bookingRefNo: "",
        //paymentStatus: "",
        bookingStatus: "",
    });

    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [summary, setSummary] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilters((prev) => ({ ...prev, [name]: value }));
    };

        const convertToDate = (str) => {
        if (!str) return null;
        const [day, month, year] = str.split("/");
        return new Date(`${year}-${month}-${day}`);
    };

    useEffect(() => {
        $("#fromDate").datepicker({
            dateFormat: "dd/mm/yy",
            // changeMonth: true,
            // changeYear: true,
            // maxDate: new Date(),
            maxDate: 0,
            onSelect: function (dateText) {
                setFilters((prev) => ({
                    ...prev,
                    fromDate: dateText,
                }));
            },
        });
    }, []);

    useEffect(() => {
        $("#toDate").datepicker({
            dateFormat: "dd/mm/yy",
            maxDate: 0,
            onSelect: function (dateText) {
                setFilters((prev) => ({
                    ...prev,
                    toDate: dateText,
                }));
            },
        });
    }, []);

    // UPDATE minDate of ToDate WHEN fromDate changes
    useEffect(() => {
        if (filters.fromDate) {
            const minD = convertToDate(filters.fromDate);
            $("#toDate").datepicker("option", "minDate", minD);
        }
    }, [filters.fromDate]);

    const handleSearch = async () => {
        setLoading(true);
        try {
            const requestBody = {
                FromDate: filters.fromDate,
                ToDate: filters.toDate,
                //TrackID: filters.transactionId,
                ReferenceNo: filters.bookingRefNo,
                //PaymentStatus: filters.paymentStatus,
                BookingStatus: filters.bookingStatus,
                UserName: "",
            };
            console.log("requestBody:", requestBody);
            const data = await InsuranceTransactionReport(requestBody);

            const all = data?.allTransactions;
            const list = data?.allTransactions || [];
            setTransactions(list);
            
        } catch (error) {
            console.error("Error fetching data:", error);
            alert(error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <HeaderDashboard />

            <div className="toolbar py-2" id="kt_toolbar">
                <div className="container-fluid d-flex align-items-center">
                    <div className="flex-grow-1">
                        <div className="page-title d-flex align-items-center flex-wrap">
                            <h1 className="text-gray-900 fw-bold fs-3">Reservations</h1>
                            <span className="h-20px border-gray-200 border-start mx-3"></span>
                            <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
                                <li class="breadcrumb-item text-muted">Insurance</li>
                                <li class="breadcrumb-item">
                                    <span class="bullet bg-gray-200 w-5px h-2px"></span>
                                </li>

                                <li class="breadcrumb-item text-gray-900">All Transactions</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            {/* Filters */}
            <section className="wraper">
                <div className="box_shadow mt-14">
                    <div className="row">
                        <div className="col-md-3 mb-3">
                            <label>From Date</label>
                            <input type="text" id="fromDate" className="form-control" placeholder="From Date" readOnly />
                        </div>
                        <div className="col-md-3 mb-3">
                            <label>To Date</label>
                            <input type="text" id="toDate" className="form-control" placeholder="To Date" readOnly />
                        </div>
                        {/* Booking RefNo */}
                        <div className="col-md-3 mb-3">
                            <label>Reference No</label>
                            <input
                                className="form-control form-control-solid"
                                type="text"
                                name="bookingRefNo"
                                value={filters.bookingRefNo}
                                onChange={handleChange}
                            />
                        </div>


                        {/* Search Button */}
                        <div className="col-md-3 mb-3">
                            <button
                                type="button"
                                className="btn btn-primary mt-7"
                                onClick={handleSearch}
                                disabled={loading}
                            >
                                {loading ? "Loading..." : "Search"}
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            {/* Results Table */}
            <section className="wraper">
                <div className="box_shadow">
                    <div className="table-responsive">
                        <table className="table align-middle gs-0 gy-4">
                            <thead>
                                <tr className="fw-bold bg-light">
                                    <th className="ps-4">Sr No</th>
                                    <th>RefNo.</th>
                                    <th>Travel Type</th>
                                    <th>Travelling Country</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                    <th>Days</th>
                                    <th>Travellers</th>
                                    <th>Status</th>
                                    {/* <th className="text-center">Action</th> */}
                                </tr>
                            </thead>

                            <tbody>
                                {transactions.length > 0 ? (
                                    transactions.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item.referenceNo}</td>
                                            <td>{item.travelType}</td>
                                            <td>{item.travellingFrom}</td>
                                            <td>{item.startDate}</td>
                                            <td>{item.endDate}</td>
                                            <td>{item.travelDays}</td>
                                            <td>{item.travellers}</td>
                                            <td>{item.status}</td>

                                            {/* <td className="text-center">
                                                <button
                                                    className="btn btn-sm btn-light"
                                                    onClick={() =>
                                                        navigate(
                                                            `/Reservations/Flight/TransactionDetails?referenceNo=${item.referenceNo}`
                                                        )
                                                    }
                                                >
                                                    View
                                                </button>
                                            </td> */}
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="10" className="text-center text-muted">
                                            {loading ? "Loading..." : "No records found"}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>
        </>
    );
};

export default AllTransactions;

